import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { TextSuiteHistoryItem } from "../Components/TextSuiteHistoryItem";
import { TextAppHistoryItem } from "../../../../Helper";
import { useOutletContext } from "react-router-dom";
import EmptySuiteHistory from "../../../VideoSuite/VideoSuiteHistory/Components/EmptySuiteHistory";

interface ContextType {
  TextAppHistoryItems: TextAppHistoryItem[];
  DeleteTextItem: (itemId: String) => void;
  isTextSuiteHistoryLoading: boolean;
  isDeleteTextItemLoading: boolean;
  isSuccessTextSuiteHistory:boolean
  isTextItemDeleted:boolean
}

export const TextSuiteHistoryContainer = () => {
  const {
    TextAppHistoryItems,
    DeleteTextItem,
    isTextSuiteHistoryLoading,
    isDeleteTextItemLoading,
    isSuccessTextSuiteHistory,
    isTextItemDeleted
  } = useOutletContext<ContextType>();
  const isEmpty = TextAppHistoryItems?.length === 0;
  return (
    <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            overflow: "hidden",
          }}
        >
      {isTextSuiteHistoryLoading && !isSuccessTextSuiteHistory ?  (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress sx={{ color: "#12b6ea" }} />
        </Box>
      ) :isSuccessTextSuiteHistory && !isEmpty? (
        <Box className="text-suite-history-container">
          {TextAppHistoryItems?.map((item, index) => (
            <Box key={index} sx={{ width: "100%" }}>
              <TextSuiteHistoryItem
                textAppItem={item}
                DeleteTextItem={DeleteTextItem}
                isTextItemDeleted={isTextItemDeleted}
                isDeleteTextItemLoading={isDeleteTextItemLoading}
              />
            </Box>
          ))}
        </Box>
      ):isSuccessTextSuiteHistory && isEmpty?(
        <EmptySuiteHistory 
          suiteRouting="/suites/text-suite"
          suiteClass="empty-text-history-image"
          suiteHeader="No Text found"
          suiteMessage="Explore all Text apps and create the creative ones with Expertex.AI"
        />
      ):null}
  </Box>
  );
};
